<template>
    <b-modal
        :visible="shallShowEmailComposeModal"
        body-class="p-2"
        size="lg"
        modal-class="modal-sticky"
        @change="discardEmail"
        @shown="modalShown"
    >
        <!-- Modal Header -->
        <template #modal-header>
            <h5 class="modal-title">
                {{ $t('Component(Label):compose-reply') }}
            </h5>
            <div class="modal-actions">
                <feather-icon
                    icon="XIcon"
                    class="ml-1 cursor-pointer"
                    @click="discardEmail"
                />
            </div>
        </template>

        <!-- Modal Footer -->
        <template #modal-footer>
            <Overlay :show="showLoading">
                <Button
                    :disabled="message.length === 0"
                    class="mr-1"
                    @click="reply"
                >
                    {{ $t('Component(Button):send') }}
                </Button>
                <Button @click="discardEmail">{{ $t('Component(Button):close') }}</Button>
            </Overlay>
        </template>

        <!-- Field: Message - Quill Editor -->
        <div class="message-editor">
            <quill-editor
                id="quil-content"
                ref="quilEditor"
                v-model="message"
                :options="editorOption"
            />
        </div>
    </b-modal>
</template>

<script>
import {quillEditor} from 'vue-quill-editor'
import Button from "@core/components/common/Button.vue";
import Overlay from "@core/components/common/Overlay.vue";

export default {
    components: {
        Button, quillEditor, Overlay
    },
    props: {
        shallShowEmailComposeModal: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            message: '',
            showLoading: false,
            editorOption:{
                modules: {
                    // toolbar: '#quill-toolbar',
                    toolbar: [
                        ['bold', 'italic', 'underline', 'strike'],
                        ['blockquote', 'code-block'],
                        [{ 'size': ['small', false, 'large', 'huge'] }],
                        [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'list': 'check' }],
                        [{ 'align': [] }],
                    ]
                },
                placeholder: this.$t('Component(Conversation):message-placeholder'),
            }
        };
    },
    methods: {
        discardEmail() {
            this.$emit('discard');
            this.message = '';
        },
        modalShown() {
            this.$refs.quilEditor.quill.focus();
        },
        reply() {
            this.showLoading = true;
            this.$emit('reply', this.message, () => {
                this.showLoading = false;
            });
        },
    },
    watch: {
        shallShowEmailComposeModal(newValue) {
            if (false === newValue && this.showLoading) {
                this.showLoading = false;
            }
        }
    }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/quill.scss';
</style>
